import React from "react";
import ParticleBlob from "./ParticleBlob";
import { Section, Button } from "./primitives";
import { cta } from "../mock/inferraData";

export default function CTASection() {
  return (
    <Section id="briefing" bg="var(--peach)" pt={170} pb={140} style={{ overflow: "hidden" }}>
      <div
        className="anim-float"
        style={{ position: "absolute", top: -120, left: "38%", opacity: 0.85, pointerEvents: "none" }}
      >
        <ParticleBlob size={340} density={95} blobs={[{ x: 0.5, y: 0.5, r: 0.34 }]} />
      </div>

      <div className="cta-row" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", gap: 70, position: "relative" }}>
        <h2
          className="font-type reveal"
          style={{ margin: 0, maxWidth: 820, fontSize: "clamp(38px, 5.6vw, 76px)", fontWeight: 700, lineHeight: 1.0, letterSpacing: "-2px" }}
        >
          {cta.heading}
        </h2>
        <div className="reveal d1" style={{ display: "flex", flexDirection: "column", gap: 14, width: 300, maxWidth: "100%" }}>
          <Button href={cta.primary.href} variant="solid" big arrow style={{ borderRadius: 999, width: "100%" }}>
            {cta.primary.label}
          </Button>
          <Button href={cta.secondary.href} variant="outline" big style={{ borderRadius: 999, width: "100%" }}>
            {cta.secondary.label}
          </Button>
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .cta-row { flex-direction: column; align-items: flex-start; gap: 34px; }
          .cta-row > div { width: 100%; }
        }
      `}</style>
    </Section>
  );
}
